import { render } from "./ProductivityDashboard.vue?vue&type=template&id=4fe8c8c8"
import script from "./ProductivityDashboard.vue?vue&type=script&lang=js"
export * from "./ProductivityDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__